/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import {
    object, shape, arrayOf, string, array,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useUIDSeed } from 'react-uid';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';

const styles = (theme)  => ({
    container: {
        [theme?.breakpoints?.down('sm')]: {
            maxWidth: theme?.palette?.tiers?.container?.maxWidth?.downSmall,
            margin: '0 auto',
        },
        [theme?.breakpoints?.down('md')]: {
            maxWidth: theme?.palette?.tiers?.container?.maxWidth?.downMedium,
            margin: '0 auto',
        },
        [theme?.breakpoints?.up('md')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
        [theme?.breakpoints?.up('lg')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
    },
    headerImg: {
        width: '100%',
        /* paddingRight: 5,
        paddingLeft: 10, */
    },
    ProductRow: {
        flex: '0 0 50%',
        width: '100%',
        padding: '15px 10px',
        position: 'relative',
        maxWidth: '50%',
        '& img': {
            width: '100%',
        },
        [theme?.breakpoints?.up(500)]: {
            flex: '0 0 25%',
            maxWidth: '25%',
            position: 'relative',
            width: '100%',
            padding: '15px 10px',
        },
    },

    productName: {
        fontWeight: '600',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    [theme?.breakpoints?.up(500)]: {
        fontWeight: 'bold',
        fontSize: '1em',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
    },
    productButton: {
        display: 'block',
        color: theme?.palette?.common?.white,
        backgroundColor: theme?.palette?.smartGiftBgColor,
        textAlign: 'center',
        fontSize: 14,
        textDecoration: 'none',
        padding: 7,
        borderRadius: 4,
        textTransform: 'uppercase',
        '&:hover': {
            backgroundColor: theme?.palette?.smartGiftHoverBgColor,
        },
    },
});
const productLink = (products, id) => {
    // below regex removes brand part of skuCode: 1001-P-148682 -> 148682
    const productData = products.filter((product) => (product?.product_sku ? product.product_sku.match(/[^-_]*$/)?.[0] === id : null));
    const product_link  = productData?.[0]?.product_link || '';
    return product_link;
};
const SmartGiftShopBlock = ({ classes, productSkus = [], data = {} }) => {
    if (!data) {
        return null;
    }
    const products = data.products || [];
    const desktopImageUrl = data?.desktop_image_banner?.url;
    const mobileImageUrl = data?.mobile_image_banner?.url;
    const seo = data.seo || {};
    const seed = useUIDSeed();
    return (
        <>
            {
                seo.seo_searchable
                    ? (
                        <Helmet>
                            <title>{seo.page_title}</title>
                            {seo.keywords && <meta name="keywords" content={seo.keywords} />}
                            {seo.meta_description && <meta name="description" content={seo.meta_description} />}
                        </Helmet>
                    ) : null
            }

            <div className={classes.container}>
                <Grid container>
                    <Grid item xs={12}>
                        <DesktopMobile
                            desktop={() => (
                                <img className={classes.headerImg} src={desktopImageUrl} alt="DesktopTop banner" />
                            )}
                            mobile={() => (
                                <img className={classes.headerImg} src={mobileImageUrl} alt="Mobile Top banner" />
                            )}
                            breakpoint={768}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    {
                        productSkus?.map((product) => {
                            const name = product?.parentProduct?.name || '';
                            const imageName = product?.image?.name || '';
                            const path = product?.image?.path || '';
                            // below regex removes brand part of skuCode: 1001-P-148682 -> 148682
                            const id = product?.id?.match?.(/[^-_]*$/)?.[0] || '';
                            return (
                                <Grid key={seed(product)} item className={classes.ProductRow}>
                                    <img src={`${path}/${imageName}x.jpg`} alt={name} className={classes.productImage} />
                                    <Grid container direction="column" className={classes.productContentWrapper}>
                                        <Grid xs={12} item>
                                            <Typography className={classes.productName}>{name}</Typography>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <a className={classes.productButton} title={name} href={productLink(products, id)}>Send Now with SmartGift</a>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })
                    }
                </Grid>
            </div>
        </>
    );
};

SmartGiftShopBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        products: array.isRequired,
        desktop_image_banner: shape({
            url: string.isRequired,
            filename: string.isRequired,
        }).isRequired,
    }).isRequired,
    productSkus: arrayOf(
        shape({
            image: shape({
                name: string.isRequired,
                path: string.isRequired,
            }).isRequired,
            parentProduct: shape({
                name: string.isRequired,
            }).isRequired,
        }),
    ).isRequired,
};
export default withStyles(styles)(SmartGiftShopBlock);
